// client/src/routes/AppRoutes.js
import { Routes, Route } from "react-router-dom";
import LoginPage from "../pages/LoginPage";
import RecuperarContrasenia from "../pages/RecuperarContrasenia";
import Dashboard from "../pages/Dashboard";
import HomePage from "../pages/public/HomePage";
import MenuPage from "../pages/public/MenuPage";
import PromocionesPage from "../pages/public/PromocionesPage";
import RestaurantesPage from "../pages/public/RestaurantesPage";
import ContactoPage from "../pages/public/ContactoPage";
import { ProtectedRoute } from "./ProtectedRoute";

export default function AppRoutes() {
  return (
    <Routes>
      {/* Rutas públicas */}
      <Route path="/" element={<HomePage />} />
      <Route path="/menu" element={<MenuPage />} />
      <Route path="/promociones" element={<PromocionesPage />} />
      <Route path="/restaurantes" element={<RestaurantesPage />} />
      <Route path="/contacto" element={<ContactoPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/recuperar-contraseña" element={<RecuperarContrasenia />} />

      {/* Rutas protegidas */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute rolesPermitidos={["admin", "mesero"]}>
            <Dashboard />
          </ProtectedRoute>
        }
      />

      <Route path="*" element={<h1>404 - Página no encontrada</h1>} />
    </Routes>
  );
}
